import * as ReactDOM from "react-dom"
import { ArticleData, SummaryDataItem } from "../../../../../articlePage/stateInterfaces"

const POINTS_CONTAINER_CLASS = "calcalistArticleHeaderV2PointsContainer"

interface CalcalistArticleHeaderV2SummaryProps {
    articleData: ArticleData
    startOpen: boolean
    usePointsContainer?: boolean
}

interface CalcalistArticleHeaderV2SummaryState {
    open: boolean
    pointsContainer: HTMLElement | null
}

export class CalcalistArticleHeaderV2Summary extends React.Component<CalcalistArticleHeaderV2SummaryProps, CalcalistArticleHeaderV2SummaryState> {
    public static siteScriptName = "CalcalistArticleHeaderV2Summary"

    constructor(props: CalcalistArticleHeaderV2SummaryProps) {
        super(props)
        this.state = { open: props.startOpen, pointsContainer: null }
    }

    public componentDidMount() {
        this.attachPointsContainer()
    }

    private attachPointsContainer = () => {
        if (!this.props.usePointsContainer || typeof document === "undefined") {
            return
        }
        const container = document.querySelector("." + POINTS_CONTAINER_CLASS) as HTMLElement | null
        if (!container) {
            return
        }
        this.setState({ pointsContainer: container })
    }

    private toggleSummary = () => {
        this.setState({ open: !this.state.open })
    }

    public static hasSummaryData(articleData: ArticleData): boolean {
        if (!articleData || articleData.summaryUpdateType === "disabled") {
            return false
        }
        const summaryData = articleData.summaryData
        if (!summaryData || summaryData.length === 0) {
            return false
        }
        let i = 0
        for (i = 0; i < summaryData.length; i++) {
            const item = summaryData[i]
            if (item && item.body && item.body.length > 0) {
                return true
            }
        }
        return false
    }

    public static parseBodyToReact(text: string): React.ReactNode {
        if (!text) {
            return null
        }
        const lines = text.split("\n").filter((l) => l.trim())
        const items: React.ReactNode[] = []
        lines.forEach((line, i) => {
            const isListItem = /^\s*(\*+|•|\.)\s*/.test(line)
            const cleanText = line.replace(/^\s*(\*+|•|\.)\s*/, "").replace(/\*+/g, "").trim()
            if (isListItem) {
                items.push(
                    <li key={"li-" + i} className="calcalistArticleHeaderV2SummaryItem">
                        {cleanText}
                    </li>
                )
            } else {
                items.push(
                    <p key={"p-" + i} className="calcalistArticleHeaderV2SummaryText">
                        {cleanText}
                    </p>
                )
            }
        })
        return <ul className="calcalistArticleHeaderV2SummaryList">{items}</ul>
    }

    public static renderPoints(summaryData: SummaryDataItem[]) {
        return _.map(summaryData, (item, i) => {
            if (!item || !item.body) {
                return null
            }
            return (
                <div key={i} className={"calcalistArticleHeaderV2SummaryBlock summaryItem-" + i}>
                    {CalcalistArticleHeaderV2Summary.parseBodyToReact(item.body)}
                </div>
            )
        })
    }

    private renderDrawer() {
        const { articleData } = this.props
        const { open, pointsContainer } = this.state
        const summaryData = articleData.summaryData
        if (!open || !summaryData) {
            return null
        }
        const drawer = (
            <div className="calcalistArticleHeaderV2Points isDrawer">
                {CalcalistArticleHeaderV2Summary.renderPoints(summaryData)}
                <div className="calcalistArticleHeaderV2PointsAi">תוכן זה נוצר בסיוע כלי בינה מלאכותית</div>
            </div>
        )
        if (pointsContainer) {
            return ReactDOM.createPortal(drawer, pointsContainer)
        }
        return drawer
    }

    render() {
        const { startOpen } = this.props
        const { open } = this.state
        const showButton = !startOpen

        return (
            <div className={"calcalistArticleHeaderV2SummaryWrap" + (open ? " isOpen" : "")}>
                {showButton &&
                    <div className="calcalistArticleHeaderV2SummaryHead">
                        <div className="calcalistArticleHeaderV2SummaryLine isStart"></div>
                        <button type="button" className="calcalistArticleHeaderV2SummaryBtn" onClick={this.toggleSummary}>
                            <span className="calcalistArticleHeaderV2SummaryBtnPlus"></span>
                            <span className="calcalistArticleHeaderV2SummaryBtnText">נקודות עיקריות</span>
                        </button>
                        <div className="calcalistArticleHeaderV2SummaryLine"></div>
                    </div>
                }
                {this.renderDrawer()}
            </div>
        )
    }
}
